import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { get_pouches } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchPouch = async (setPouch, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await get_pouches();
    if (response.statusText=="OK") {
      const data = response?.data;
      setPouch(data?.pouches);
    } else {
      message.error("Failed to fetch pouch.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching pouch.");
  }
};
